import React from "react";
import { Link } from "react-router-dom";
import logoSvg from "../assets/Triagz_Mark_ColorDark.svg";
import logoFull from "../assets/Triagz_Logo_Primary_ColorDark@2x.png";
import "../styles/Logo.css";

const Logo = ({ 
  size = "medium", // Options: small, medium, large, xlarge, xxlarge
  showText = true, 
  linkTo = "/", 
  className = "", 
  onClick = null,
  textClassName = "",
  isClickable = true,
  useFullLogo = false
}) => {
  const logoContent = (
    <div className={`logo-container ${size} ${className} ${useFullLogo ? 'full-logo' : ''}`}>
      <img 
        src={useFullLogo ? logoFull : logoSvg} 
        alt="Triagz Logo" 
        className={`logo-svg ${useFullLogo ? 'full-img' : ''}`}
      />
      {showText && !useFullLogo && <span className={`logo-text ${textClassName}`}>triagz</span>}
    </div>
  );

  if (!isClickable) {
    return logoContent;
  }

  if (onClick) {
    return (
      <button onClick={onClick} className="logo-button">
        {logoContent}
      </button>
    );
  }

  return (
    <Link to={linkTo} className="logo-link">
      {logoContent}
    </Link>
  );
};

export default Logo; 